import { TranslateModule } from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BasicProjectFormComponent } from './basic-project-form.component';
import { ReactiveFormsModule } from '@angular/forms';
import { AutoFocusModule } from 'primeng/autofocus';
import { CalendarModule } from 'primeng/calendar';
import { InputTextModule } from 'primeng/inputtext';
import {InputSwitchModule} from 'primeng/inputswitch';
import {DropdownModule} from 'primeng/dropdown';
import {ImageModule} from 'primeng/image';
import { OrganizationDialogModule } from 'projects/shared-lib/src/lib/organization-dialog/organization-dialog.module';
import { PrimeUploadFilesModule } from '@a2-primeng/prime-upload-files/prime-upload-files.module';
import {EditorModule} from 'primeng/editor';
import { TooltipModule } from 'primeng/tooltip';
import { ProgressBarModule } from 'primeng/progressbar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';


@NgModule({
  declarations: [
    BasicProjectFormComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputTextModule,
    AutoFocusModule,
    CalendarModule,
    InputSwitchModule,
    DropdownModule,
    OrganizationDialogModule,
    TranslateModule,
    PrimeUploadFilesModule,
    ImageModule,
    EditorModule,
    TooltipModule,
    ProgressBarModule,
    ConfirmDialogModule
  ],
  exports: [
    BasicProjectFormComponent
  ]
})
export class BasicProjectFormModule { }
